import { render, staticRenderFns } from "./CustomerUserInfo.vue?vue&type=template&id=2f86a15f&scoped=true"
import script from "./CustomerUserInfo.vue?vue&type=script&lang=js"
export * from "./CustomerUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86a15f",
  null
  
)

export default component.exports